export * from './src/premium-domains-v1-connected-domain-connected-domains.meta.js';
